import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Route guard. Route data:
 *   module: 'MY_RESUMES'      -> role must have View on that module
 *   superAdminOnly: true      -> Super Admin only
 * Users flagged mustChangePassword are kept on /security/change-password until they change it.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.auth.isLoggedIn) { return this.router.createUrlTree(['/signin'], { queryParams: { returnUrl: state.url } }); }

    if (this.auth.session.mustChangePassword && !state.url.startsWith('/security/change-password')) {
      return this.router.createUrlTree(['/security', 'change-password']);
    }
    // A forced password change must always be reachable, whatever the role's module rights.
    if (this.auth.session.mustChangePassword) { return true; }
    const data = route.data || {};
    if (data.superAdminOnly && !this.auth.isSuperAdmin) { return this.router.createUrlTree(['/dashboard']); }
    if (data.module && !this.auth.can(data.module)) { return this.router.createUrlTree(['/dashboard']); }
    return true;
  }
}

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}
  canActivate(): boolean | UrlTree {
    return this.auth.isLoggedIn ? this.router.createUrlTree(['/dashboard']) : true;
  }
}
